/**
 * @file components/CardImageWrap/component.js
 * @copyright 2020 CBC/Radio-Canada. All rights reserved.
 */

import VideoLinkImageOverlay from "../../../VideoLinkImageOverlay/component.js";
import { Image } from "../../../Image/component";
import classNames from "classnames";

/**
 * Function representing the CardImageWrap component.
 *
 * Contains the images as well as the VideoLinkImageOverlay component on cards.
 *
 * @param {Object} props The component props
 * @returns {JSX.Element} Returns the CardImageWrap component
 */
export default function CardImageWrap(props) {
    const { imageProps, videoLinkImageOverlayProps, className } = props;
    return (
        <div
            className={classNames("cardImageWrap", className)}
            data-testid="card-image-wrap"
        >
            <Image {...imageProps} />
            <VideoLinkImageOverlay {...videoLinkImageOverlayProps} />
        </div>
    );
}
